import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Gift, MoonStar, School, CalendarDays } from 'lucide-react';
const bonuses = [{
  id: 'B1',
  icon: MoonStar,
  iconColor: 'text-indigo-600',
  iconBg: 'bg-indigo-50',
  title: 'PROTOCOLO DE CRISIS 2 AM',
  desc: 'Sistema de clasificación de crisis en 4 niveles con protocolo de acción paso a paso para cada uno. Incluye técnicas de calma para la madre, manejo emocional del niño por edad y tabla de decisión de cuándo ir a la guardia.',
  tagline: 'Para imprimir y pegar en el dormitorio.'
}, {
  id: 'B2',
  icon: School,
  iconColor: 'text-emerald-600',
  iconBg: 'bg-emerald-50',
  title: 'MANUAL ESCOLAR "RESPIRO SEGURO"',
  desc: 'Documento completo para entregar al colegio al inicio del año. Incluye ficha médica del alumno, guía para docentes, protocolo de crisis en el aula, administración del inhalador, adaptaciones para educación física y protocolo del comedor escolar.',
  tagline: 'Para que el colegio sepa exactamente cómo proteger a tu hijo.'
}, {
  id: 'B3',
  icon: CalendarDays,
  iconColor: 'text-amber-600',
  iconBg: 'bg-amber-50',
  title: 'CALENDARIO ESTACIONAL ARGENTINO 2026',
  desc: 'Mapa de riesgo mes a mes para todo el año 2026 con calendarios específicos por región (GBA, Córdoba, Mendoza, Patagonia, NOA, NEA). Incluye protocolo de preparación para cada estación y alertas por Zonda, Sudestada y Asma de Tormenta.',
  tagline: 'Para anticiparte antes de que llegue el riesgo.'
}];
export const Bonuses = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-brand-green text-white relative overflow-hidden" data-id="element-16">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-17">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-18"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-orange rounded-full blur-3xl" data-id="element-19"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-20">
        <div className="text-center mb-8 sm:mb-12" data-id="element-21">
          <div className="inline-flex items-center gap-2 bg-brand-gold text-white font-bold px-4 py-1.5 rounded-full text-sm mb-4 sm:mb-6" data-id="element-22">
            <Gift size={16} data-id="element-23" /> INCLUIDOS GRATIS
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold mb-3 sm:mb-4" data-id="element-24">
            3 BONOS INCLUIDOS GRATIS
          </h2>
          <p className="text-lg sm:text-xl text-cream/90" data-id="element-25">
            Los Recursos de Acción Inmediata
          </p>
          <p className="text-sm sm:text-base text-cream/80 mt-2" data-id="element-26">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 mb-10 sm:mb-14 md:mb-16" data-id="element-27">
          {bonuses.map((bonus, i) => {
          const IconComponent = bonus.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} whileHover={{
            y: -4,
            transition: {
              duration: 0.2
            }
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: i * 0.1
          }} className="bg-white text-gray-900 rounded-2xl p-4 sm:p-5 shadow-lg border-t-4 border-brand-gold relative cursor-default" data-id="element-28">
                <div className="absolute -top-3 right-4 bg-brand-orange text-white text-xs font-bold px-2.5 py-0.5 rounded-full shadow-sm" data-id="element-29">
                  GRATIS
                </div>

                <div className={`w-16 h-16 ${bonus.iconBg} rounded-xl flex items-center justify-center mb-3 sm:mb-4`} data-id="element-30">
                  <IconComponent size={32} className={bonus.iconColor} data-id="element-31" />
                </div>

                <h3 className="font-bold text-base sm:text-lg mb-2 leading-tight" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mb-2 line-clamp-4" data-id="element-33">
                  {bonus.desc}
                </p>
                <p className="text-brand-green text-xs font-bold italic" data-id="element-34">
                  {bonus.tagline}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 sm:p-6 md:p-8 text-center max-w-3xl mx-auto" data-id="element-35">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold" data-id="element-36">
            VALOR TOTAL:{' '}
            <span className="line-through text-white/50" data-id="element-37">$45.000</span>{' '}
            <span className="text-brand-gold" data-id="element-38">— GRATIS</span>
          </h3>
        </div>
      </div>
    </section>;
};